import React from 'react';

import { CalendarDays } from 'lucide-react';

import type { SimpleIconInterface } from './icon-utils';

export function DateFieldIcon(props: SimpleIconInterface): JSX.Element {
  const { className, dataCy, height, stroke, strokeWidth, style, width } = props;

  return (
    <CalendarDays
      className={className}
      data-cy={dataCy}
      height={height ?? 18}
      stroke={stroke ?? 'currentColor'}
      strokeWidth={strokeWidth}
      style={style}
      width={width ?? 18}
    />
  );
}
